var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container py-3" }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between mb-3" },
      [
        _c("h2", { staticClass: "mb-0" }, [
          _vm._v(" Performers — "),
          _c("small", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.stageName)),
          ]),
        ]),
        _c("span", { staticClass: "badge bg-light text-dark" }, [
          _vm._v(_vm._s(_vm.performers.length) + " total"),
        ]),
      ]
    ),
    !_vm.performers.length
      ? _c("div", { staticClass: "text-muted my-4" }, [
          _vm._v(" No performers found for this stage. "),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.performers, function (p, idx) {
        return _c(
          "div",
          { key: p._id, staticClass: "col-md-4 col-sm-6 mb-4 d-flex" },
          [
            _c(
              "div",
              {
                staticClass:
                  "card performer-card mx-auto text-center shadow-sm",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-body pt-3 pb-3 d-flex flex-column align-items-center",
                  },
                  [
                    _c("div", { staticClass: "photo-wrapper mb-3" }, [
                      p.profile_picture
                        ? _c("img", {
                            staticClass:
                              "photo img-fluid border rounded shadow-sm d-block mx-auto",
                            attrs: {
                              src: p.profile_picture,
                              alt: "Performer photo",
                            },
                          })
                        : _c(
                            "div",
                            {
                              staticClass:
                                "photo placeholder bg-light border rounded d-flex align-items-center justify-content-center text-muted",
                            },
                            [_vm._v(" No photo ")]
                          ),
                    ]),
                    _c("h5", { staticClass: "card-title mb-1" }, [
                      _vm._v(_vm._s(p.name)),
                    ]),
                    _c("div", { staticClass: "mt-1" }, [
                      _c(
                        "span",
                        { staticClass: "badge bg-secondary rounded-pill" },
                        [_vm._v(" " + _vm._s(p.performer_type) + " ")]
                      ),
                    ]),
                    p.about
                      ? _c(
                          "p",
                          { staticClass: "card-text mt-2 about clamp-3" },
                          [_vm._v(" " + _vm._s(p.about) + " ")]
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-footer bg-transparent d-flex justify-content-center border-top",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-danger btn-sm",
                        attrs: { disabled: _vm.deletingId === p._id },
                        on: {
                          click: function ($event) {
                            return _vm.onDelete(p, idx)
                          },
                        },
                      },
                      [
                        _vm.deletingId === p._id
                          ? _c("span", [_vm._v("Deleting…")])
                          : _c("span", [_vm._v("Delete")]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }